import { styled } from "@mui/material";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import { useState, useEffect } from "react";
import SettingsModal from "../Modal/settingsCustomModal";
import UpdateRoutePayment from "./editRoutePayment";
import DeleteRoutePayment from "./deleteRoutePayment";
import css3 from "../../Approvals/css/approval-table.module.css";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";

interface DynamicTableProps {
  data: RoutePayment[] | undefined;
}

interface RoutePayment {
  RoutPaymentId: number;
  RoutId: number;
  RouteName: string;
  ActionId: number;
  ActionName: string;
  Amount: number;
  Amount_B: number;
  PaymentActive: boolean;
  OrderOfPayment: number;
  TargetedMembersId: number;
  TargetedMembers: string;
}

export default function DynamicTable({ data }: DynamicTableProps) {
  const [deleteRoutePayment, setDeleteRotePayment] = useState(false);
  const [RoutePaymentModal, setRoutePaymentModal] = useState(false);
  const [object, setObject] = useState();
  const [activeData, setActiveData] = useState<any>([]);
  const [pageData, setPageData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [pageArr, setPageArr] = useState<any>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<any>(null);

  const DATA_PER_PAGE = 10;

  const handlePrevous = () => {
    if (currentPage === 0) {
      if (pageArr.length > 1) {
        setCurrentPage(pageArr.at(-1));
        return false;
      }
      setCurrentPage(0);
      return false;
    }
    setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (pageArr.length > 1) {
      if (currentPage === pageArr.at(-1)) {
        setCurrentPage(0);
        return false;
      }
      setCurrentPage(currentPage + 1);
      return false;
    }
    setCurrentPage(0);
  };

  const handleRoutePaymentModal = (data: any) => {
    setObject(data);
    setRoutePaymentModal(true);
  };

  const handleDeleteRoutePayment = (data: any) => {
    setObject(data);
    setDeleteRotePayment(true);
  };

  const handleMore = (index: number) => {
    if (index == showIndex) {
      setShowIndex(null);
      setShowMore(false);
      return;
    }
    setShowIndex(index);
    setShowMore(true);
  };

  const handleCloseRoutePaymentModal = () => setRoutePaymentModal(false);
  const handleCloseDeleteRoutePaymentModal = () => setDeleteRotePayment(false);

  useEffect(() => {
    if (data && data.length > 0) {
      setActiveData(data);

      let lastPage = Math.ceil(data.length / 10);
      let i = 0;
      let arr = [];
      for (i = 0; i < lastPage; i++) {
        arr.push(i);
      }

      setPageArr(arr);
      setPageData(data.slice(0, DATA_PER_PAGE));
    }
  }, [data]);

  useEffect(() => {
    if (activeData && activeData.length > 0) {
      let start = currentPage * DATA_PER_PAGE;
      let stop = start + DATA_PER_PAGE;
      setPageData(data?.slice(start, stop));
    }
  }, [currentPage]);

  return (
    <Wrapper>
      <div className={css3.container}>
        <>
          <div style={{ gridTemplateColumns: `repeat(6,.8fr) 1fr` }}>
            <div>Route Payment Id</div>
            <div>Route Name</div>
            <div>Payment Action</div>
            <div>Amount</div>
            <div>NYSC Amount</div>
            <div> Payment Order</div>
            <div>Target Membership</div>
          </div>
          <div>
            {pageData &&
              pageData?.length > 0 &&
              pageData?.map((eData: RoutePayment, index: number): any => (
                <div
                  key={index}
                  style={{ gridTemplateColumns: `repeat(6,.8fr) 1fr` }}
                >
                  <div>{eData?.RoutPaymentId}</div>
                  <div>{eData?.RouteName}</div>
                  <div>{eData?.ActionName}</div>
                  <div>{eData?.Amount || "N/A"}</div>
                  <div>{eData?.Amount_B || "N/A"}</div>
                  <div>{eData?.OrderOfPayment}</div>
                  <div>
                    <div>{eData?.TargetedMembers}</div>

                    <span
                      className={`${css3.moreSpan} ${
                        index == showIndex ? `${css3.activeMore}` : ""
                      } `}
                      onClick={() => handleMore(index)}
                    >
                      <MoreIcon />
                      {index == showIndex && showMore ? (
                        <div>
                          <div onClick={() => handleRoutePaymentModal(eData)}>
                            Edit
                          </div>
                          {/* <div onClick={()=>handleDeleteRoutePayment(eData)}>Delete</div> */}
                        </div>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              ))}
          </div>
          <div className={css3.pagination}>
            <div>
              <button
                onClick={handlePrevous}
                className={`${css3.lBtn} ${css3.btn}`}
              >
                <LBtn />
              </button>
              {pageArr &&
                pageArr.length > 0 &&
                pageArr.map((ePage: number, index: number) => {
                  if (index <= 2 && currentPage <= 2)
                    return (
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage + 1}
                      </span>
                    );

                  if (index == currentPage)
                    return (
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage + 1}
                      </span>
                    );

                  if (
                    index >= pageArr.length - 3 &&
                    currentPage >= pageArr.length - 3
                  )
                    return (
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage + 1}
                      </span>
                    );

                  if (index == pageArr.length - 1)
                    return (
                      <>
                        <>...</>
                        <span
                          style={
                            ePage == currentPage
                              ? {
                                  backgroundColor: "var(--activeP-back)",
                                  color: "var(--white-color)",
                                }
                              : {}
                          }
                          key={ePage}
                          onClick={() => setCurrentPage(ePage)}
                        >
                          {ePage + 1}
                        </span>
                      </>
                    );

                  if (index == 0)
                    return (
                      <>
                        <span
                          style={
                            ePage == currentPage
                              ? {
                                  backgroundColor: "var(--activeP-back)",
                                  color: "var(--white-color)",
                                }
                              : {}
                          }
                          key={ePage}
                          onClick={() => setCurrentPage(ePage)}
                        >
                          {ePage + 1}
                        </span>
                        <>...</>
                      </>
                    );
                })}
              <button
                onClick={handleNext}
                className={`${css3.rBtn} ${css3.btn}`}
              >
                <RBtn />
              </button>
            </div>
          </div>
        </>
      </div>

      <SettingsModal
        open={RoutePaymentModal}
        cancel={handleCloseRoutePaymentModal}
        maxWidth="800px"
        header="Update Route Payment"
        showrightIcon={false}
        content={
          <UpdateRoutePayment
            RoutePaymentDetails={object}
            handleClose={handleCloseRoutePaymentModal}
          />
        }
      />
      <SettingsModal
        open={deleteRoutePayment}
        cancel={handleCloseDeleteRoutePaymentModal}
        maxWidth="480px"
        header="Delete Route Payment"
        showrightIcon={false}
        content={
          <DeleteRoutePayment
            RoutePaymentDetails={object}
            handleClose={handleCloseDeleteRoutePaymentModal}
          />
        }
      />
    </Wrapper>
  );
}

const Wrapper = styled("div")`
  margin-inline: 48px;
`;
